import { Block } from "baseui/block";
import { Button, SIZE } from "baseui/button";
import { ButtonGroup, MODE } from "baseui/button-group";
import { Checkbox, LABEL_PLACEMENT, STYLE_TYPE } from "baseui/checkbox";
import { DatePicker } from "baseui/datepicker";
import { FormControl } from "baseui/form-control";
import { useState } from "react";
import { StateVariable } from "../../../../utils/stateVariable";
import { FlexDate } from "../types";
import { useIntl, FormattedMessage } from 'react-intl';
import { Accordion, Panel } from "baseui/accordion";
import { useGetLanguage } from "../../../../hooks/useGetLanguage";

export interface IFlexDateFormProps {
    value: StateVariable<FlexDate>,
}

const FlexDateForm = (props: IFlexDateFormProps) => {
    const intl = useIntl();
    const { language, locale } = useGetLanguage();
    const state = props.value.value;
    const setState = props.value.setValue;

    const [selected, setSelected] = useState<number>(0);

    const onDateChanged = (e: any) => {
        setState((prevState) => ({
            ...prevState,
            date: e.date
        }))
    };

    const onEveryYearChanged = (e: any) => {
        setState((prevState) => ({
            ...prevState,
            flexYear: e.target.checked
        }))
    };

    const onEveryDayChanged = (e: any) => {
        setState((prevState) => ({
            ...prevState,
            flexDay: e.target.checked
        }))
    };

    const onFixMonthClicked = (e: any) => {
        setState((prevState) => ({
            ...prevState,
            flexMonth: false,
            evenMonths: false,
            oddMonths: false
        }))
        setSelected(0);
    };

    const onEveryMonthClicked = (e: any) => {
        setState((prevState) => ({
            ...prevState,
            flexMonth: true,
            evenMonths: false,
            oddMonths: false
        }))
        setSelected(1);
    };

    const onEvenMonthClicked = (e: any) => {
        setState((prevState) => ({
            ...prevState,
            flexMonth: false,
            evenMonths: true,
            oddMonths: false
        }))
        setSelected(2);
    };

    const onOddMonthClicked = (e: any) => {
        setState((prevState) => ({
            ...prevState,
            flexMonth: false,
            evenMonths: false,
            oddMonths: true
        }))
        setSelected(3);
    };

    return (
        <Block display='flex' flexDirection='column' gridGap='20px'>
            <FormControl
                label={() => intl.formatMessage({ id: "dateInput", defaultMessage: "Date" })}
                caption={() => intl.formatMessage({ id: "dateInputDescr", defaultMessage: "Select a date" })}
            >
                <DatePicker
                    value={state.date}
                    onChange={onDateChanged}
                    locale={locale}
                    formatString='P'
               
                />
            </FormControl>
            <Accordion
                accordion
            >
                <Panel title={<><FormattedMessage id="Calendar.UseFlexDate" defaultMessage="use flexible date" /> ...</>}>
                    <>
                        <FormControl
                            label={() => "Flexible Year"}
                            caption={() => "Change to use this date every year"}
                        >
                            <Checkbox
                                checked={state.flexYear}
                                checkmarkType={STYLE_TYPE.toggle}
                                onChange={onEveryYearChanged}
                                labelPlacement={LABEL_PLACEMENT.right}
                            >
                                Every year
                            </Checkbox>
                        </FormControl>
                        <FormControl
                            label={() => "Flexible Month"}
                            caption={() => "Change to use flexible month settins"}
                        >
                            <ButtonGroup size={SIZE.compact} mode={MODE.radio} selected={selected}>
                                <Button onClick={onFixMonthClicked}>FIX</Button>
                                <Button onClick={onEveryMonthClicked}>Every month</Button>
                                <Button onClick={onEvenMonthClicked}>Event months</Button>
                                <Button onClick={onOddMonthClicked}>Odd months</Button>
                            </ButtonGroup>

                        </FormControl>
                        <FormControl
                            label={() => "Flexible Year"}
                            caption={() => "Change to use this date every year"}
                        >
                            <Checkbox
                                checked={state.flexDay}
                                checkmarkType={STYLE_TYPE.toggle}
                                onChange={onEveryDayChanged}
                                labelPlacement={LABEL_PLACEMENT.right}
                            >
                                Every day
                            </Checkbox>
                        </FormControl>
                    </>
                </Panel>
            </Accordion>

        </Block >
    );
}

export default FlexDateForm;